import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { STORAGE_URL } from "constants";
import { useFetch, useLanguage, useToggle } from "hooks";
import { Icons, RatingStars } from "components";

export default function BookCard({ item }) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { user, access_token } = useSelector((state) => state.auth); // call data from auth store
  const [bookmarked, toggleBookmarked] = useToggle(item.is_favor);
  const [_, bookFavouriteRequest] = useFetch(`User/addRemoveFavorites`, "POST");

  const handleAddRemoveFavourite = () => {
    toggleBookmarked();
    bookFavouriteRequest({
      book_id: item.id,
    });
  };

  return (
    <div className="book_card position-relative bg-light rounded-4">
      <div className="px-4 mb-2">
        <div className="d-flex justify-content-center px-3 mb-2 book-img">
          {item.cover_image && (
            <img
              src={`${STORAGE_URL}${item.cover_image}`}
              title="figure"
              alt={item.title}
            />
          )}
        </div>

        <Row>
          <Col xs={12}>
            <ul className="links_types-ul list-group list-group-horizontal bg-transparent gap-2">
              {item.links_types &&
                item.links_types.length > 0 &&
                item.links_types.map((item, i) => (
                  <li
                    key={i}
                    className="d-flex align-items-center justify-content-center bg-transparent gap-1 border-0 p-0"
                  >
                    <img
                      src={`${STORAGE_URL}${item.icon}`}
                      width="25"
                      height="25"
                      alt={item.type}
                    />
                    <p className="fw-normal text-light3 py-0 my-0">
                      {item.type}
                    </p>
                  </li>
                ))}
            </ul>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h5 className="fw-bold text-black cut-text-2 h6 description">
              {item.name}
            </h5>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs={6}>
            <div className="d-flex align-items-center">
              <RatingStars rate={item.rate} />
            </div>
          </Col>
          <Col xs={6} className="d-flex align-items-center">
            <Icons.Users width="16" className="svg-fill-light4" />
            <h6 className="fw-normal text-light4 mx-1">
              {item.readers_count || 0} {language.reader}
            </h6>
          </Col>
        </Row>
        {user && access_token && (
          <Icons.Favourite
            onClick={handleAddRemoveFavourite}
            role="button"
            className={`position-absolute favourite ${
              bookmarked ? "active" : ""
            }`}
            active={bookmarked}
          />
        )}
      </div>
      <NavLink
        className="position-absolute end-0 start-0 bottom-0"
        to={`/book/${item.id}`}
      >
        <div className="view_button user-select-none px-4 py-1 bg-light2">
          <Row className="align-items-center">
            <Col xl={10} lg={10} md={10} sm={10} xs={10}>
              <h6 className="fw-bold m-0">{language.showtheBook}</h6>
            </Col>
            <Col xl={2} lg={2} md={2} sm={2} xs={2}>
              <Icons.ArrowLeft />
            </Col>
          </Row>
        </div>
      </NavLink>
    </div>
  );
}
